import image1 from '@/assets/images/news/detail/20210105/1.jpg';
import image2 from '@/assets/images/news/detail/20210105/2.jpg';
import image3 from '@/assets/images/news/detail/20210105/3.jpg';
import image4 from '@/assets/images/news/detail/20210105/4.jpg';
import image5 from '@/assets/images/news/detail/20210105/5.jpg';
import image6 from '@/assets/images/news/detail/20210105/6.jpg';

export default {
  id: '20210105', //  模块 id
  title: '2021叮咚买菜新年日历 | 伴我一路前行', // 标题
  origin: '', // 新闻来源
  editor: '', // 编辑者
  content: [
    {
      type: 0,
      text: '叮咚2021新年礼品暖心定制',
      isIndent: false,
    },
    {
      type: 0,
      text: '新IP保萝亮相',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image1],
    },
    {
      type: 1,
      title: '',
      src: [image2],
    },
    {
      type: 0,
      text: '愿你的2021',
      isIndent: false,
    },
    {
      type: 0,
      text: '像“保萝”一样有趣、可爱',
      isIndent: false,
    },
    {
      type: 0,
      text: '保持对生活的热爱',
      isIndent: false,
    },
    {
      type: 0,
      text: '拥有爱吃的灵魂',
      isIndent: false,
    },
    {
      type: 0,
      text: '让叮咚买菜',
      isIndent: false,
    },
    {
      type: 0,
      text: '陪你品味一日三餐',
      isIndent: false,
    },
    {
      type: 0,
      text: '与你走过一年四季',
      isIndent: false,
    },
    {
      type: 1,
      title: '',
      src: [image3, image4],
    },
    {
      type: 1,
      title: '',
      src: [image5, image6],
    },
    {
      type: 0,
      text: '一月',
      isIndent: false,
    },
    {
      type: 0,
      text: '小孩小孩你别馋 过了腊八就是年',
      isIndent: false,
    },
    {
      type: 0,
      text: '二月',
      isIndent: false,
    },
    {
      type: 0,
      text: '春节不打烊 叮咚送吉祥',
      isIndent: false,
    },
    {
      type: 0,
      text: '三月',
      isIndent: false,
    },
    {
      type: 0,
      text: '春色满园关不住 送枝桃花到你家',
      isIndent: false,
    },
    {
      type: 0,
      text: '四月',
      isIndent: false,
    },
    {
      type: 0,
      text: '清明到 雨来到 青团香香好味道',
      isIndent: false,
    },
    {
      type: 0,
      text: '五月',
      isIndent: false,
    },
    {
      type: 0,
      text: '一骑红尘妃子笑 叮咚一响荔枝到',
      isIndent: false,
    },
    {
      type: 0,
      text: '六月',
      isIndent: false,
    },
    {
      type: 0,
      text: '万水千山「粽」是情 见不到你就不行',
      isIndent: false,
    },
    {
      type: 0,
      text: '七月',
      isIndent: false,
    },
    {
      type: 0,
      text: '儿时西瓜味 好吃又不贵',
      isIndent: false,
    },
    {
      type: 0,
      text: '八月',
      isIndent: false,
    },
    {
      type: 0,
      text: '江南可采莲 叮咚送清甜',
      isIndent: false,
    },
    {
      type: 0,
      text: '九月',
      isIndent: false,
    },
    {
      type: 0,
      text: '但愿人长久 千里共餐桌',
      isIndent: false,
    },
    {
      type: 0,
      text: '十月',
      isIndent: false,
    },
    {
      type: 0,
      text: '重阳佳节赏菊花 登高望远秋色华',
      isIndent: false,
    },
    {
      type: 0,
      text: '十一月',
      isIndent: false,
    },
    {
      type: 0,
      text: '万「柿」开头难 坚持下去就不难',
      isIndent: false,
    },
    {
      type: 0,
      text: '十二月',
      isIndent: false,
    },
    {
      type: 0,
      text: '咕噜噜 咕噜噜 围炉火锅暖呼呼',
      isIndent: false,
    },
  ],
};
